import React, { useEffect, useState, FC, useRef } from "react";
import { Button, message, Tooltip } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useBmsPurchasePoDetailsModel } from "../bmsBillPurchasePoModel"

export const FormBox: FC<RouterParamType> = () => {
    const { detailLookForm, getDetailEditOne, resetLookCatch,
    } = useBmsPurchasePoDetailsModel()
    const formRef = useRef<IYhFormRef>();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, parentInfo } = detailsInfo

    useEffect(() => {
        getDetailEditOne(id)
    }, [id])
    useEffect(() => {
        return () => {
            resetLookCatch();
        }
    }, [selectedNavId])



    const title = <>
        <span>基础信息</span>
        {/* <Tooltip placement="topLeft" title="采购历史">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip> */}
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购单号",
                fieldName: "purchaseCode",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: '供应商名称',
                fieldName: "supplierName",
                rules: [{ required: true, message: "请选择供应商" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请填入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属门店",
                fieldName: "shopName",
                disable: true,
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "采购类型",
                fieldName: "purchaseTypeName",
                rules: [{ required: true, message: "请选择采购类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型",
                fieldName: "supplierTypeName",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购实体",
                fieldName: "bentityName",
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择采购实体" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "商品类型",
                fieldName: "materialTypeName",
                allowClear: true,
                showSearch: true,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请输入结算类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算方式",
                fieldName: "payMethodName",
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请输入结算方式" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "是否直发",
                fieldName: "isDirect",
                allowClear: true,
                showSearch: true,
                options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
                span: 5,
                labelCol: { offset: 1 },
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "none",
                span: 1,
                labelCol: { offset: 5 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "厂家订单号",
                fieldName: "orderCode",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "deliveryMethod",
                allowClear: true,
                showSearch: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                allowClear: true,
                showSearch: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单员",
                fieldName: "createUser",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 12,
                labelCol: { span: 3 },
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管员",
                fieldName: "storekeeper",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "入库时间",
                fieldName: "stockIoTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算时间",
                fieldName: "settleTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "核销时间",
                fieldName: "settleTime",
                hidden: more,
                disable: true,
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型code",
                fieldName: "supplierTypeCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "商品类型名称",
                fieldName: "materialTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购类型名称",
                fieldName: "purchaseTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运输方式名称",
                fieldName: "deliveryMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型名称",
                fieldName: "invoiceTypeName",
                hidden: true
            }

        ]
    };


    const poFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        disabled: true,
        labelAlign: "right",
        formValues: detailLookForm,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}